document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".book-tabs-wrapper").forEach((wrapper) => {
    const tabs = wrapper.querySelectorAll(".book-tab-title");
    const contents = wrapper.querySelectorAll(".book-tab-content");

    const initializeSwiper = (swiperContainer) => {
      if (
        swiperContainer &&
        !swiperContainer.classList.contains("swiper-initialized")
      ) {
        const settings = JSON.parse(swiperContainer.dataset.settings || "{}");

        new Swiper(swiperContainer, {
          loop: settings.loop || false, // 👈 استخدم القيمة من PHP

          speed: settings.speed || 3000,
          spaceBetween: settings.spaceBetween || 30,
          autoplay: {
            delay: settings.speed || 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          simulateTouch: true,
          grabCursor: true,

          // navigation: {
          //   nextEl: swiperContainer.querySelector(".swiper-button-next"),
          //   prevEl: swiperContainer.querySelector(".swiper-button-prev")
          // },
          pagination: {
            el: swiperContainer.querySelector(".swiper-pagination"),
            clickable: true
          },
          breakpoints: {
            0: {
              slidesPerView: settings.mobile || 1
            },
            768: {
              slidesPerView: settings.tablet || 2
            },
            1024: {
              slidesPerView: settings.desktop || 3
            }
          }
        });

        swiperContainer.classList.add("swiper-initialized");
      }
    };

    // تهيئة أول تبويب
    const activeContent = wrapper.querySelector(".book-tab-content.active");
    if (activeContent) {
      const swiperContainer = activeContent.querySelector(".rb-book-swiper");
      initializeSwiper(swiperContainer);
    }

    // التبديل بين التبويبات
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("active"));
        contents.forEach((c) => c.classList.remove("active"));

        tab.classList.add("active");

        const tabId = tab.getAttribute("data-tab");
        const target = wrapper.querySelector("#" + tabId);
        if (target) {
          target.classList.add("active");
          const swiperContainer = target.querySelector(".rb-book-swiper");
          initializeSwiper(swiperContainer);
        }
      });
    });
  });
});
